import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => {
  return {
    awardsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: '56px',
      '& img': {
        display: 'block',
        marginRight: 12,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
    appleAward: {
      height: 62,
    },
    googleAward: {
      height: 62,
    },
  };
});

const AwardsContainer = () => {
  const classes = useStyles();
  return (
    <div className={classes.awardsContainer}>
      <img className={classes.appleAward} src="/img/home-page/apple-award-1.svg" alt="apple award" />
      <img className={classes.appleAward} src="/img/home-page/apple-award-2.svg" alt="apple award" />
      <img className={classes.googleAward} src="/img/home-page/google-award.svg" alt="android award" />
    </div>
  );
};

export default AwardsContainer;
